module.exports = ".top-btn {\n  background-color: #fecc00;\n  color: #000;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  padding: 7px 30px;\n  display: inline-block;\n}\n\n.active {\n  background-color: #000;\n  color: #fecc00;\n}\n\n.graph-item {\n  width: 45%;\n  margin: auto;\n  display: inline-block;\n}\n\n::ng-deep .numberformat {\n  text-align: right;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/billing/billing-list/billing-list.component.scss
// module id = ./src/app/system/billing/billing-list/billing-list.component.scss
// module chunks = main